<template>
	<div>
		<div class="bio-pane active">
			<div class="search-bar">
				<el-form ref="form" label-width="120px">
					<label>日期 <el-date-picker size="small" style="width:220px" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" v-model="filter.date" @change="handleFilter(3,1, $event)"></el-date-picker></label>
					<div style="display: inline-block;">
						数据源
						<el-select size="small" filterable clearable placeholder="请选择" v-model="filter.dataType" @change="handleFilter(3,2, $event)">
							<el-option v-for="item in sourceList" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</div>
					<div class="flr">
						<el-button type="primary" size="mini" round @click="onShowForm('add')">添加血尿酸</el-button>
						<el-link class="mode noline" :class="{active: viewMode == 1}" @click="handleMode(1)"><i class="icon-table"></i></el-link>
						<el-link class="mode noline" :class="{active: viewMode == 2}" @click="handleMode(2)"><i class="icon-chart2"></i></el-link>
					</div>
				</el-form>
			</div>
			
			<div class="pane-mode table-wrap" :class="{active: viewMode == 1}">
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading">
					<el-table-column prop="lisDate" label="测量时间" show-overflow-tooltip min-width="120"></el-table-column>
					<el-table-column label="血尿酸(umol/L)" min-width="120">
						<template slot-scope="scope"><span class="lv" :class="['lv'+ scope.row.uaLevel]">{{ scope.row.itemResult ? scope.row.itemResult : '未测量'}}</span>{{scope.row.itemRange ? '('+scope.row.itemRange+')' : ''}}</template>
					</el-table-column>
					<el-table-column prop="dataType" label="数据源" width="100">
						<!-- <template slot-scope="scope">
							<span v-if="scope.row.dataType == 0">入院</span>
							<span v-else-if="scope.row.dataType == 1">出院</span>
							<span v-else-if="scope.row.dataType == 2">门诊</span>
							<span v-else-if="scope.row.dataType == 3">随访</span>
						</template> -->
					</el-table-column>
					<el-table-column fixed="right" label="操作" width="100" >
						<template slot-scope="scope">
							<div class="tab-action" v-if="scope.row.dataType=='后台录入'">
								<el-tooltip content="修改" slot="reference" placement="top" :enterable="false">
										<i @click="onShowForm(scope.row)" class="el-icon-edit" />
								</el-tooltip>
								<el-popconfirm confirmButtonText='删除' title="确定删除吗？"  @confirm="delItem(scope.row)">
									<el-tooltip content="删除" slot="reference" placement="top" :enterable="false">
											<i class="el-icon-delete"></i>
									</el-tooltip>
								</el-popconfirm>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>				
			</div>
			<div class="pane-mode chart" :class="{active: viewMode == 2}">
				<chart :options="chartOpts"></chart>
			</div>
		</div>


		<el-dialog :title.sync="dialogTit" width="550px" center :visible.sync="isFormActive">
			<el-form ref="form" label-width="120px" :rules="rules" :model="form">
				<el-form-item label="测量时间：" prop="lisDate">
					<el-date-picker v-model="form.lisDate" value-format="yyyy-MM-dd HH:mm:ss" :clearable="false" type="datetime"></el-date-picker>
				</el-form-item>
				<el-form-item label="血尿酸：" prop="itemResult">
					<el-input clearable v-model="form.itemResult" ></el-input> mmol/L
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button type="primary" :loading="isLoading" @click="onSave">保 存</el-button>
			</div>
		</el-dialog>	


	</div>	
</template>

<script>
import mixin from '@/views/mixin';
import {Chart} from 'highcharts-vue';
import api from '@/service/api.js';
import dayjs from 'dayjs';
import { throttle } from "throttle-debounce";

export default {
	components: {Chart},
  mixins: [mixin],
	props: {
		patientId: { required: true }
	},
	data(){
		let checkResult = (rule, value, callback) => {
			if (!Number(value)) return callback(new Error('请输入数字值'))
			let reg = /((^[1-9]\d*)|^0)(\.\d{0,9}){0,1}$/;
			if (!reg.test(value)) return callback(new Error('请输入正确数值'));
			callback();
		}
		return {
			noSidebar: true,
			sourceList:[],
			dialogTit:'',
			filter:{
				patientId: 0,
				dataType: '',
				type:'',
				startTime: '',
				endTime: '',
				date: [],
				pageNumber: 1,
				pageSize: 30
			},
			viewMode: 1,
			isFormActive: false,
			rules: {
				itemResult: [{required: true, message: '请输入',},
					{ validator: checkResult, trigger: 'blur' }],
			},			
			form: {
				patientId: 0,
				lisDate: undefined,
				itemResult: undefined,
				dataType: 3,
				dataId: 0,
			},
			list: {pageSize: 30, pageCount: 50, total: 300,data: []},
			chartOpts: {
				title: {
					style: {color: '#2f4b6a'},
					// text: '最近1468天趋势图',
					text: null,
				},
				subtitle: {
					useHTML: true,
					style: {color: '#55759b'},
					text: undefined,
				},
				legend: {
					x: -50,
					borderWidth: 1,
					borderRadius: 5,
					layout: 'vertical',
					align: 'right',
					verticalAlign: 'top',
					floating: true
				},		
				tooltip: {valueSuffix: 'umol/L'},
				credits: {enabled: false},
				yAxis: {
					title: {style: {color: '#55759b'},text: '(umol/L)'},
				},
				xAxis: {
					categories: undefined
				},
				plotOptions: {
					line: {
						dataLabels: { enabled: true },
						enableMouseTracking: true
					}
				},				
				series: undefined
			}		
		}
	},
	created() {
		// let query = this.$route.query;
		this.filter.patientId = this.patientId;
		this.loadList();
		
		// 获取 来源下拉
		api.getPatientBioSourceType({}).then((res)=>{
			if (res.code == 1000 && res.data) {
				this.sourceList = res.data;
			}
		});
	},
	methods: {
		async loadList(){
			// 获取 血压数据
			const filter = JSON.parse(JSON.stringify(this.filter));
			filter.date = undefined;
			let res = await api.getPatientUA(filter);
			if (res.code == 1000 && res.data) {
				if (res.data) {
					res.data.forEach((item)=>{
						item.uaLevel = this.getLevel(1,item.itemTip);
					})
					this.list.total = +res.total;
					this.list.current = this.filter.pageNumber;
					this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);					
					this.list.data = res.data;

					let labels = [];
					let dataUa = [];
					res.data?.forEach(item => {
						labels.push(item.lisDate);
						dataUa.push(+item.itemResult);
					});
					// 图表数据
					this.chartOpts.xAxis.categories = labels.reverse();
					this.chartOpts.series = [
						{
							name: '血尿酸',
							color: 'blue',
							data: dataUa.reverse()
						}
					];
					if (labels.length > 0) {
						this.chartOpts.subtitle.text = `<div>血尿酸(峰值:${Math.max(...dataUa)}umol/L 谷值:${Math.min(...dataUa)}umol/L 均值: ${this.MathAvg(dataUa)}umol/L)</div>`;	
					} else {
						this.chartOpts.subtitle.text = undefined;
					}
					
				}
			}

		},
		// 求平均值
		MathAvg(arr) {
			return (arr.reduce((pre, cur) => pre + cur) / arr.length).toFixed(1);
		},
		handleMode(key) {
			this.viewMode = key;
		},
		handleFilter(key, val) {
			if(val == 1){
				// 时间筛选
				if (this.filter.date) {
					this.filter.startTime = dayjs(this.filter.date[0]).format('YYYY-MM-DD 00:00:00');
					this.filter.endTime = dayjs(this.filter.date[1]).format('YYYY-MM-DD 23:59:59');
				} else {
					this.filter.startTime = '';
					this.filter.endTime = '';						
				}
			}
			this.filter.pageNumber = 1;
			this.loadList();
		},
		onShowForm(item) {
			this.isFormActive = true;
			if(item=='add'){
				this.dialogTit='添加血尿酸'
				this.$refs['form'].resetFields();
				this.form.lisDate = dayjs().format('YYYY-MM-DD HH:mm:ss');
				this.form.itemResult=undefined;
			} else {
				this.dialogTit='修改血尿酸'
				this.form.lisDate=item.lisDate;
				this.form.itemResult=item.itemResult;
				this.form.id=item.id;
			}

		},
		onSave:throttle(3000,true,function(){
			this.$refs['form'].validate(async (valid)=>{
				if (valid) {
					this.form.patientId = this.patientId;
					if(this.dialogTit=='添加血尿酸'){
						let res = await api.addPatientUA(this.form);
						if (res.code != 1000) {
							this.$message.console.error(res.msg);
							return;
						}
						this.$message.success('添加成功');
					} else {
						let res = await api.updatePatientLabBloodUa(this.form);
						if (res.code != 1000) {
							this.$message.console.error(res.msg);
							return;
						}
						this.$message.success('修改成功');
					}
					this.isFormActive = false;
					this.loadList();
				}
			});
		}) ,
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},
		getLevel(v,key){
			if(v != 0){
				switch(key){
					case '高': return 4;
					case '低': return 1;
					default : return 0;
				}
			}
		},
		async delItem(item){
			let res =await api.delPatientLabBloodUa([String(item.id)]);
			if(res.code==1000){
				this.$message.success('删除成功');
				this.loadList();
			}
		}
	}
}	
</script>
<style lang="less" scoped>
.tab-action{
	display: flex;
	justify-content: center;
}
</style>